import axios from "axios";

const API = process.env.REACT_APP_API_URL;

// Sends a 6-digit OTP to the given phone number.
// Phone must be a 10-digit Indian mobile number (no country code).
export const sendOtp = async (phone) => {
  const res = await axios.post(`${API}/otp/send`, { phone });
  return res.data;
};

// Verifies the OTP entered by the user.
export const verifyOtp = async (phone, otp) => {
  const res = await axios.post(`${API}/otp/verify`, { phone, otp });
  return res.data;
};

// Fetches OTP settings (otpEnabled, otpMandatory) for the registration form.
export const getMobileVerificationSettings = async () => {
  const res = await axios.get(`${API}/settings/mobile-verification`);
  return res.data;
};
